export const POST_HOG_EVENT = {
  AUTH_PAGE: {
    LANDED: 'auth-page-landed',
    SIGNUP_SCREEN_LANDED: 'auth-page-signup-screen-landed',
    SIGNIN_SCREEN_LANDED: 'auth-page-signin-screen-landed',
    EXTERNAL_REFERRAL_LANDED: 'auth-page-external-referral-landed',
    LANDING_PAGE_REFERRAL: 'auth-page-landing-page-referral'
  },
  BACKEND: {
    TIMED_OUT: 'backend-timed-out',
    ERRORED: 'backend-errored-out'
  },
  TODO_PLAYER_BRIDGE: {
    METADATA_RECEIVED: 'todo-player-bridge-metadata-received',
    FOCUS_PLAYER_INITIALIZED: 'todo-player-bridge-focus-player-initialized',
    INTENTION_LOADED: 'todo-player-bridge-intention-loaded',
    BRAIN_DUMP_UPDATED: 'todo-player-bridge-brain-dump-updated',
    SYNC_WITH_DEVICES_RECEIVED: 'todo-player-bridge-sync-with-devices-received',
    SELECTED_TASK_SYNCED: 'todo-player-bridge-selected-task-synced',
    FOCUS_PAUSED_FROM_DESKTOP: 'todo-player-bridge-focus-paused-from-desktop'
  },
  SIGN_UP: {
    VIEWED: 'sign-up-viewed',
    START_EMAIL_FLOW_CLICKED: 'sign-up-start-email-flow-clicked',
    SUBMIT_CLICKED: 'sign-up-submit-clicked',
    SUCCESS: 'sign-up-success',
    ERROR: 'sign-up-error',
    TERMS_NOT_ACCEPTED: 'sign-up-terms-not-accepted',
    GOOGLE_SIGN_UP_SUCCESS: 'google-sign-up-success',
    APPLE_SIGN_UP_SUCCESS: 'apple-sign-up-success',
    REDIRECT_TO_DESKTOP_SUCCESS: 'redirect-to-desktop-sign-up-success'
  },
  SIGN_IN: {
    VIEWED: 'sign-in-viewed',
    SUBMIT_CLICKED: 'sign-in-submit-clicked',
    SUCCESS: 'sign-in-success',
    ERROR: 'sign-in-error',
    GOOGLE_SIGN_IN_SUCCESS: 'google-sign-in-success',
    APPLE_SIGN_IN_SUCCESS: 'apple-sign-in-success',
    REDIRECT_TO_DESKTOP_SUCCESS: 'redirect-to-desktop-sign-in-success'
  },
  GOOGLE_LOGIN: {
    CLICKED: 'google-login-clicked',
    SUCCESS: 'google-login-success',
    ERROR: 'google-login-error'
  },
  APPLE_LOGIN: {
    CLICKED: 'apple-login-clicked',
    SUCCESS: 'apple-login-success',
    ERROR: 'apple-login-error'
  },
  SIGN_UP_DIRECT: 'sign-up-direct',
  SIGN_UP_VIA_HABIT_PACK: 'sign-up-via-habit-pack',
  SIGN_UP_VIA_FOCUS_TEMPLATE: 'sign-up-via-focus-template',
  TODO_PLAYER_ADD_TASK_BUTTON_CLICKED: 'todo-player-add-task-button-clicked',
  TODO_PLAYER_EXISTING_TASK_ADDED_FROM_ADD_TASK_UI:
    'todo-player-existing-task-added-from-add-task-ui',
  TODO_PLAYER_BRAINDUMP_AI_BUTTON_CLICKED:
    'todo-player-braindump-ai-button-clicked',
  TODO_PLAYER_TASK_PLAY_BUTTON_CLICKED: 'todo-player-task-play-button-clicked',
  TODO_PLAYER_NEW_TASK_CREATED: 'todo-player-new-task-created',
  TODO_PLAYER_TASK_STARTED: 'todo-player-task-started',
  FOCUS_SUMMARY: 'focus_summary',
  ROUTINE_SUGGESTIONS_GOALS_SELECTION_CONTINUE_BUTTON_CLICKED:
    'routine-suggestions-goals-selection-continue-button-clicked',
  ROUTINE_SUGGESTIONS_ROUTINE_SELECTION_CONTINUE_BUTTON_CLICKED:
    'routine-suggestions-routine-selection-continue-button-clicked',
  ROUTINE_SUGGESTIONS_ROUTINE_DURATION_CONTINUE_BUTTON_CLICKED:
    'routine-suggestions-routine-duration-continue-button-clicked',
  ROUTINE_SUGGESTIONS_SUGGEST_HABITS_FOR_ME_BUTTON_CLICKED:
    'routine-suggestions-suggest_habits_for_me_button-clicked',
  ROUTINE_SUGGESTIONS_EDIT_HABITS_BUTTON_CLICKED:
    'routine-suggestions-edit-habits-button-clicked',
  ROUTINE_SUGGESTIONS_USE_GENERATED_BUTTON_CLICKED:
    'routine-suggestions-use-generated-button-clicked',
  ROUTINE_SUGGESTIONS_EXPLORE_HABIT_PACKS_BUTTON_CLICKED:
    'routine-suggestions-explore-habit-packs-button-clicked',
  ROUTINE_SUGGESTIONS_INSTALL_HABIT_PACK_BUTTON_CLICKED:
    'routine-suggestions-install-habit-pack-button-clicked',
  ROUTINE_SUGGESTIONS_ADJUST_ROUTINE_ENHANCE_HABITS_BUTTON_CLICKED: (
    routine: string
  ) =>
    `routine-suggestions-adjust-${routine}-routine-enhance-habits-button-clicked`,
  PERSONAL_SUBSCRIPTION_GET_STARTED_BUTTON_CLICKED:
    'personal-subscription-get-started-button-clicked',
  TEAM_SUBSCRIPTION_GET_STARTED_BUTTON_CLICKED:
    'team-subscription-get-started-button-clicked',
  RENEW_SUBSCRIPTION_BUTTON_CLICKED: 'renew-subscription-button-clicked',
  CHANGE_PAYMENT_METHOD_BUTTON_CLICKED: 'change-payment-method-button-clicked',
  ADD_PAYMENT_METHOD_BUTTON_CLICKED: 'add-payment-method-button-clicked',
  CANCEL_SUBSCRIPTION_BUTTON_CLICKED: 'cancel-subscription-button-clicked',
  CANCEL_SUBSCRIPTION_CONTINUE_BUTTON_CLICKED:
    'cancel-subscription-continue-button-clicked',
  ENROL_IN_COURSE: 'enrol-in-course',
  COMPLETE_COURSE_LESSON: 'complete-course-lesson',
  COMPLETE_ENTIRE_COURSE: 'complete-entire-course',
  COURSE_COMPLETED_FEEDBACK: 'course-completed-feedback',
  ROUTINE_SUGGESTIONS_NO_SUGGESTIONS_GENERATED:
    'routine-suggestions-no-suggestions-generated',
  ROUTINE_SUGGESTIONS_HABIT_TITLE_EDIT_HABIT_BUTTON_CLICKED:
    'routine-suggestions-habit-title-edit-habit-button-clicked',
  PROJECT_MANAGEMENT_SYNC_EXPRESSION_OF_INTEREST:
    'project-management-sync-expression-of-interest',
  SURVEY_RATING_OUT_OF_FIVE: 'survey-rating-out-off-five',
  ROUTINE_SUGGESTIONS_NO_GIVE_ME_SOME_IDEAS_BUTTON_CLICKED:
    'routine-suggestions-no-give-me-some-ideas-button-clicked',
  ROUTINE_SUGGESTIONS_YUP_I_WILL_SETUP_MY_EXISTING_HABITS_BUTTON_CLICKED:
    'routine-suggestions-yup-i-will-setup-my-existing-habits-button-clicked',
  DELETE_HABIT_CONFIRM: 'delete-habit-confirm',
  ROUTINE_SUGGESTIONS_CUSTOM_TIMING_EXPRESS_INTEREST_BUTTON_CLICKED:
    'routine-suggestions-custom-timing-express-interest-button-clicked',
  ROUTINE_SUGGESTIONS_CREATE_YOUR_OWN_HABITS_BUTTON_CLICKED:
    'routine-suggestions-create-your-own-habits-button-clicked',
  WEB_ONBOARDING: {
    ONBOARDING_PAGE_VISIBLE: 'web-onboarding-page-visible',
    DATA_PRIVACY_SCREEN_VISIBLE: 'web-onboarding-data-privacy-screen-visible',
    DATA_PRIVACY_CONTINUE_BUTTON_CLICKED:
      'web-onboarding-data-privacy-continue-button-clicked',
    PERSONALIZED_SETUP_SKIP_BUTTON_CLICKED:
      'web-onboarding-personalized-setup-skip-button-clicked',
    PERSONALIZED_SETUP_NO_THANKS_BUTTON_CLICKED:
      'web-onboarding-personalized-setup-no-thanks-button-clicked',
    FEATURES_CONTINUE_BUTTON_CLICKED:
      'web-onboarding-features-continue-button-clicked',
    ENABLE_FEATURES_BUILD_HEALTHY_HABITS:
      'web-onboarding-enable-feature-build-healthy-habits',
    ENABLE_FEATURES_STAY_FOCUSED: 'web-onboarding-enable-feature-stay-focused',
    CREATE_APPOINTMENT_NO_THANKS_BUTTON_CLICKED:
      'web-onboarding-create-appointment-no-thanks-button-clicked',
    CREATE_APPOINTMENT_SOUNDS_GREAT_BUTTON_CLICKED:
      'web-onboarding-create-appointment-sounds-great-button-clicked',
    CREATE_APPOINTMENT_ZOOM_BUTTON_CLICKED:
      'web-onboarding-create-appointment-zoom-button-clicked',
    CREATE_APPOINTMENT_WHATSAPP_BUTTON_CLICKED:
      'web-onboarding-create-appointment-whatsapp-button-clicked',
    SELECTED_GOALS: 'web-onboarding-selected-goals',
    GOALS_CONTINUE_BUTTON_CLICKED:
      'web-onboarding-goals-continue-button-clicked',
    SELECTED_ROUTINES: 'web-onboarding-selected-routines',
    ROUTINES_BREAK_DURING_WORK_ON: 'web-onboarding-break-during-work-on',
    ROUTINES_BREAK_DURING_WORK_OFF: 'web-onboarding-break-during-work-off',
    ROUTINES_CONTINUE_BUTTON_CLICKED:
      'web-onboarding-routines-continue-button-clicked',
    ROUTINE_HABITS_EDIT_HABITS_BUTTON_CLICKED:
      'web-onboarding-routine-habits-edit-habits-button-clicked',
    ROUTINE_HABITS_CONTINUE_BUTTON_CLICKED:
      'web-onboarding-routine-habits-continue-button-clicked',
    CREATE_SCHEDULE_SKIP_BUTTON_CLICKED:
      'web-onboarding-create-schedule-skip-button-clicked',
    CREATE_SCHEDULE_CONTINUE_BUTTON_CLICKED:
      'web-onboarding-create-schedule-continue-button-clicked',
    BEARSONA_PROFILE_CONTINUE_BUTTON_CLICKED:
      'web-onboarding-bearsona-profile-continue-button-clicked',
    DOWNLOAD_APP_LINK_CLICKED: (platform: string) =>
      `web-onboarding-download-${platform.toLowerCase()}-link-clicked`,
    SLEEP_SYNC_QUESTION_YES_PLEASE_BUTTON_CLICKED:
      'web-onboarding-sleep-sync-question-yes-please-button-clicked',
    SLEEP_SYNC_QUESTION_NO_THANKS_BUTTON_CLICKED:
      'web-onboarding-sleep-sync-question-no-thanks-button-clicked',
    ADJUST_ROUTINE_ENHANCE_HABITS_BUTTON_CLICKED: (routine: string) =>
      `web-onboarding-adjust-${routine}-routine-enhance-habits-button-clicked`,
    TIME_SUMMARY_EDIT_BUTTON_CLICKED:
      'web-onboarding-time-summary-edit-button-clicked'
  },
  REDIRECT_TO_MANAGE_SUBSCRIPTION_VIA_WEBVIEW:
    'redirect-to-manage-subscription-via-webview',
  DESKTOP: {
    REDIRECT_VIEWED: 'desktop_redirect_viewed',
    AUTH_FLOW_ERROR: 'auth_flow_error',
    DEEPLINK_ATTEMPTED: 'desktop_deeplink_attempted',
    DEEPLINK_SUCCEEDED: 'desktop_deeplink_succeeded',
    DEEPLINK_FALLBACK_FIRED: 'desktop_deeplink_fallback_fired',
    DEEPLINK_RETRY_CLICKED: 'desktop_deeplink_retry_clicked',
    DOWNLOAD_WINDOWS_APP_CLICKED: 'desktop_download_windows_app_link_clicked',
    DOWNLOAD_MAC_APP_CLICKED: 'desktop_download_mac_app_link_clicked'
  },
  WEB_PROFILE: {
    PRIVACY_SECTION_VIEWED: 'web-profile-privacy-section-viewed',
    PRIVACY_SECTION_EXPANDED: 'web-profile-privacy-section-expanded'
  },
  PRIVACY_MODAL: {
    SHOWN: 'web-privacy-modal-shown',
    DISMISSED: 'web-privacy-modal-dismissed',
    VIEWED_FULL: 'web-privacy-modal-viewed-full'
  },
  ROUTINE_SUGGESTIONS_REVAMP: {
    FEATURE_GOAL_SELECTED: 'routine-suggestions-revamp-feature-goal-selected',
    CONTINUE_CLICKED: 'routine-suggestions-revamp-continue-clicked'
  }
};

export const MOBILE_APP_EVENT = {
  SUGGESTED_ACTIVITIES_INSTALLED: 'suggested-activities-installed',
  SEND_SELECTED_HABIT_PACK_ID: 'send-selected-habit-pack-id',
  EDIT_HABITS_ENABLED: 'edit-habits-enabled',
  SAVED_USER_SETTINGS: 'saved-user-settings',
  CLOSE_SURVEY_UI: 'close-survey-ui'
};

export const AI_EVENT = {
  FATAL_ERROR: 'FatalError'
};

export const PLATFORMS_MESSAGE_HANDLER = {
  USER_SETTINGS_UPDATED: 'user-settings-updated',
  USER_SETTINGS_UPDATE_FAILED: 'user-settings-update-failed'
};

export const AUTH_EVENT = {
  UPDATED: 'auth:updated',
  EMBEDDED_AUTH_FAILED: 'auth:embedded-failed',
  EMBEDDED_NETWORK_UNAVAILABLE: 'auth:embedded-network-unavailable',
  TOKEN_REQUEST_STARTED: 'auth:token-request-started',
  TOKEN_REQUEST_ENDED: 'auth:token-request-ended'
};

// Internal DOM event the native shells trigger (via window.fbNavigate) to switch the
// embedded SPA between webview screens without a full reload.
export const WEBVIEW_EVENT = {
  NAVIGATE: 'webview:navigate'
};
